<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='"background-image: url(\"https:\/\/api.saratavakoli-master.ir\/storage\/assets\/patern.png\");\nbackground-repeat: no-repeat;\nbackground-position:right;\n\n"' class="bg-secondary" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"\n"' class="container pb-5" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="mx-auto text-center" >
                <template #default>   <m-h1 v-bind='{...{},...{}}' :style='"font-size:45px;\ntext-shadow: black 1px 0 15px;"' class="pt-5 pb-3 text-white" >
                <template #default>رزرو وقت   </template>
                </m-h1></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='"border-radius:25px;\nbackground-image: url(\"https:\/\/api.saratavakoli-master.ir\/storage\/assets\/Mandala-8.webp\");\nbackground-repeat: no-repeat;\nbackground-color:#ffffffcf;\n\n"' class="row  p-4 border shadow " >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-lg-12  p-2 mt-2 col-md-12" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"background:#ffffff;\nborder-radius:15px;"' class="h-100 shadow border p-3" >
                <template #default>   <m-p v-bind='{...{},...{}}' :style='""' class="text-center" >
                <template #default>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان جامعه و متخصصان را می طلبد، تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی، و فرهنگ پیشرو در زبان فارسی ایجاد کرد، در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها، و شرایط سخت تایپ به پایان رسد و زمان مورد نیاز شامل حروفچینی دستاوردهای اصلی، و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.   </template>
                </m-p></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='"background: #18858A;\n"' class="container-fluid " >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"\nbackground:var(--secondary) ;\nbackground-image: url(\"https:\/\/api.rastavisa.com\/storage\/contents\/bgpatern2.png\");\nbackground-repeat: no-repeat;\nbackground-size: cover;\n"' class="row d-flex  justify-content-center align-items-center p-5\n" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class=" col-md-6 col-12 text-center p-4" >
                <template #default>   <m-h1 v-bind='{...{},...{}}' :style='"color: #000 !important;\n\n\n"' class="" >
                <template #default>رزرو وقت مشاوره    </template>
                </m-h1><m-p v-bind='{...{},...{}}' :style='""' class="text-dark" >
                <template #default>ثبت اطلاعات   </template>
                </m-p></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-md-6 col-12 text-center pb-3" >
                <template #default>   <m-product-add-to-cart-2 v-bind='{...{"productLink":"\u0631\u0632\u0631\u0648-\u0648\u0642\u062a","advanceDescription":false,"advanceDescriptionInputs":"","defaultGate":"zarinpal"},...{}}' :style='""' class="" ></m-product-add-to-cart-2></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH1 from '@moeinmdn/miw-alpha-components/src/package/Tags/H1'; import mP from '@moeinmdn/miw-alpha-components/src/package/Tags/P'; import mProductAddToCart2 from '@moeinmdn/miw-alpha-components/src/package/Tool/ProductAddToCart/ProductAddToCart2';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mH1,mP,mProductAddToCart2 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
